/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 23, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 25" fill="none">
    <path d="M18 2.31445L22 6.31445M17 7.31445L20 4.31445M19 9.31445L8.7 19.6145C7.7 20.6145 6.2 20.6145 5.3 19.6145L4.7 19.0145C3.7 18.0145 3.7 16.5145 4.7 15.6145L15 5.31445M9 11.3145L13 15.3145M5 19.3145L2 22.3145M14 4.31445L20 10.3145" stroke="#262626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
